import { watch } from 'vue';
import { useRegisterSW } from 'virtual:pwa-register/vue';
import { defineNuxtPlugin } from '#app';
import checkPWAMethods from '~/utils/checkPWAMethods';

export default defineNuxtPlugin((nuxtApp) => {
  const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW();

  nextTick(() => {
    watch(needRefresh, async (newVal) => {
      if (newVal && checkPWAMethods()) {
        const confirmUpdate = confirm('Доступно новое обновление. Хотите обновить приложение?');
        if (confirmUpdate) {
          await updateServiceWorker();
        }
      }
    });
  });
});
